import React, { createContext, useContext, useState, useCallback, useEffect, ReactNode } from 'react';
import { GlobalAudioService, GlobalAudioState } from '@/services/audio/GlobalAudioService';

interface AudioContextType {
  audioState: GlobalAudioState;
  isAudioActive: boolean;
}

const AudioContext = createContext<AudioContextType | undefined>(undefined);

export const AudioProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [audioState, setAudioState] = useState<GlobalAudioState>(GlobalAudioService.getState());

  useEffect(() => {
    const unsubscribe = GlobalAudioService.subscribe(setAudioState);
    return () => {
      unsubscribe();
    };
  }, []);

  const isAudioActive = audioState.isPlaying || audioState.isPaused;

  return (
    <AudioContext.Provider value={{ audioState, isAudioActive }}>
      {children}
    </AudioContext.Provider>
  );
};

export const useAudioContext = () => {
  const context = useContext(AudioContext);
  if (!context) {
    return {
      audioState: GlobalAudioService.getState(),
      isAudioActive: false,
    };
  }
  return context;
};
